module.exports = __webpack_public_path__ + "static/4-9f50f2e6d5f6cd754fa79bb3238fe9a4.jpg";